import { render, staticRenderFns } from "./businessPlan.vue?vue&type=template&id=381b93cd&scoped=true&"
import script from "./businessPlan.vue?vue&type=script&lang=ts&"
export * from "./businessPlan.vue?vue&type=script&lang=ts&"
import style0 from "./businessPlan.vue?vue&type=style&index=0&id=381b93cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b93cd",
  null
  
)

export default component.exports